import React, { Children, cloneElement, isValidElement, useState } from 'react'
//material-ui
import { makeStyles } from '@material-ui/core/styles'
//component
import Box from './Box'
import Button from './Button'

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    },
  },
}))

export default ({ children, ...props }) => {
  const classes = useStyles()
  const validChildrenArray = Children.toArray(children).filter(isValidElement)
  const fieldNames = validChildrenArray.map(child => child.props.name)
  const initialState = fieldNames.reduce(
    (acc, name) => ({ ...acc, [name]: '' }),
    {}
  )
  const [state, setState] = useState(initialState)

  function onSubmit(e) {
    e.preventDefault()
    console.log(state)
  }

  function onChange(e) {
    const { name, value } = e.target

    setState({ ...state, [name]: value })
  }

  return (
    <Box as="form" className={classes.root} {...props} onSubmit={onSubmit}>
      {validChildrenArray.map((child, index) => {
        return cloneElement(child, {
          value: state[child.props.name],
          onChange,
          style: { width: '48%' },
        })
      })}
      <Button type="submit" color="primary" round>
        Absenden
      </Button>
    </Box>
  )
}
